import { combineReducers } from 'redux';

import app from './app';
import auth from './auth';
import scanner from './scanner';
// import angkatan from './angkatan';
import guests from './guests';
import guest from './guest';
import instansi from './instansi';
import stats from './stats';

const rootReducer = combineReducers({
  app,
  auth,
  scanner,
  // angkatan,
  guests,
  guest,
  instansi,
  stats
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/modules/index.js